import { DepartmentType } from '#src/generated/types'
import { ExpertProfilePhotoFragment } from '../fragments/ExpertProfilePhoto.generated'
import { RecommendedExpertForProductPageFragment } from '../routes/products/graphql/RecommendedExpert.generated'

interface DepartmentExpertHeadlineInput {
  departmentType?: DepartmentType
  plural?: boolean
}

export const getDepartmentExpertHeadline = ({
  departmentType,
  plural = false
}: DepartmentExpertHeadlineInput) => {
  const expert = plural ? 'Experts' : 'Expert'
  switch (departmentType) {
    case DepartmentType.CYCLING:
      return `Cycling ${expert}`

    case DepartmentType.GOLF:
      return `Golf ${expert}`

    case DepartmentType.WINTER_SPORTS:
      return `Winter Sports ${expert}`

    case DepartmentType.YACHT_CHARTERS:
      return `Yacht Charters ${expert}`

    case DepartmentType.CAMPING:
      return `Camping & Hiking ${expert}`

    case DepartmentType.FISHING:
      return `Fishing ${expert}`

    default:
      return `Curated ${expert}`
  }
}

export const getExpertImageAltText = (expert: ExpertProfilePhotoFragment) => {
  return `${expert.expertProfile?.headline || 'Curated Expert'} ${expert.displayName}`
}

export const getRecommendedExpertNotAssistant = (
  expert?: RecommendedExpertForProductPageFragment | null
) => {
  return expert?.expertAttributes.placeholderExpert ? undefined : expert
}
